import React, { Fragment, lazy, Suspense } from 'react';

import ReactDOM from "react-dom";
import App from "./App";
import { logBuildInfo } from "./@common/utils/logBuildInfo";
import * as serviceWorker from "./serviceWorker";
import { I18nextProvider } from 'react-i18next';
import I18n from './i18n';

import "./i18n";
import { isNoCssPrintView } from './@common/utils/print.helpers';


const MainStyles = lazy(() => import(/* webpackChunkName: 'MainStyles' */"./MainStyles"));


logBuildInfo();
serviceWorker.unregister();

ReactDOM.render(
    <Fragment>
        <Suspense fallback={<div />}>
            {!isNoCssPrintView() && <MainStyles />}
            <I18nextProvider i18n={I18n} >
                <App />
            </I18nextProvider>
        </Suspense>
    </Fragment>,
    document.getElementById("root")
);